module.exports = __webpack_public_path__ + "img/bg@2x.17557e71.png";